import { Injectable } from '@angular/core';



export enum LogLevel {
    Debug = 1,
    Info = 2,
    Warning = 3,
    Error = 4,
}

@Injectable()
export class LogEntry {
    // Public Properties
    type: LogLevel;
    eventdate: Date;
    message: string = '';
    constructor() {
        this.type = LogLevel.Error;
        this.message = '';
        this.eventdate = new Date();
    }
}

@Injectable()
export class LogService {

    public entry: LogEntry = new LogEntry();


    // Log To LocalStorage
    localstorage(level: LogLevel, msg: string): void {

        const timestamp = new Date();

        this.entry.type = level;
        this.entry.message = msg;
        this.entry.eventdate = timestamp;


        const LocalStorageKey: LogLevel = level;
        let key = '';

        switch (LocalStorageKey) {
            case LogLevel.Debug: {
                key = 'Debug';
                break;
            }
            case LogLevel.Error: {
                key = 'Errors';
                break;
            }
            case LogLevel.Info: {
                key = 'Info';
                break;
            }
            case LogLevel.Warning: {
                key = 'Warning';
                break;
            }
            default: {
                key = '';
                break;
            }
        }


        let values: LogEntry[];
        let sorted: LogEntry[];
        let logdata: LogEntry[];

        // Get previous values from local storage
        values = JSON.parse(localStorage.getItem(key)) || [];
        // Add new log entry to array
        values.push(this.entry);
        // Sort Log Entry Array
        sorted = this.sortlocalstorage(values);
        // Clear localstorage if more then 10 entry
        logdata = this.clear(sorted, 50);
        // Store array into local storage
        localStorage.setItem(key, JSON.stringify(logdata));
    }

    // Log To DataBase
    database(level: LogLevel, msg: string): void {
        // Todo: Will have to be implemented
    }

    // Log To FireBase
    firebase(level: LogLevel, msg: string): void {
        // Todo: Will have to be implemented
    }

    // Clear log entries from local storage
    clear(LogData: LogEntry[], buffersize: number): LogEntry[] {
        if (LogData.length >= buffersize) {
            LogData = LogData.slice(0, buffersize);
        }
        return LogData;
    }

    // Sorts Error by Date Descending order
    sortlocalstorage(arr: LogEntry[]) {
        const sortedArray: LogEntry[] = arr.sort((a, b) => new Date(b.eventdate).getTime() - new Date(a.eventdate).getTime());
        return sortedArray;
    }

}
